import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { useFliptFeature } from "~/hooks/useFliptFeature";
import { ROUTE_404, FliptFlagKey } from "~/router/constants";

/**
 * Flag gate for a route, composed outside the permission gate so a caller who
 * holds the permission but is not in the rollout gets the same 404 as anyone
 * else. Waits for Flipt rather than redirecting on its initial `false`.
 */
export const FliptFeatureRoute = ({
  flagKey,
  children,
}: {
  flagKey: FliptFlagKey;
  children: ReactNode;
}) => {
  const { enabled, isLoading } = useFliptFeature(flagKey);

  if (isLoading) {
    return <Loading />;
  }
  if (!enabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <>{children}</>;
};
